import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import _ from 'lodash';

//Daterangepicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

// chart.js module
import moment from 'moment';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-moment";
import annotationPlugin from 'chartjs-plugin-annotation';

// UI Components
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import Spinner from "COMPONENTS/Spinner/Spinner";

import { getMessage } from "CONFIG/i18n";
import { organisationAction } from "CONFIG/ActionFactory";

import "../AdminDashboard.less";
import "./UsageReport.less";
import "./SessionList.less";

//ASSETS
import calendar_img from "ASSETS/Images/Calendar.svg";
import ic_save_icon from "ASSETS/Images/ic_save_icon.svg";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

ChartJS.register(annotationPlugin);

export default class usageReport extends Component{

  constructor(props){
    super(props);
    this.state={
      dropdownOpen: false,
      scheduleDate: moment().subtract(1, "days"),
      scheduleDateError: "",
      focused: null,
      currentSelectedItem: "day",
      dropDownValue: getMessage("USAGE_REPORT_DAILY"),
      isLoading: false,
      isDownloadEnabled: false,
      buttonDisabled: false,
      concurrentSession: {
        data: null,
        options: null
      },
      accumulatedSession: {
        data: null,
        options: null
      },
      sendSmsCount: {
        data: null,
        options: null
      },
      diskUsage: {
        data: null,
        options: null
      }
    };
  }

  componentDidMount() {
    this.showGraph();
  }

  changeDate = (date) => {
    this.setState({ scheduleDate: date });
  }

  search = async () => {
    try {
      this.setState({ buttonDisabled: true });
      await this.showGraph();
    } catch (error) {
      console.error("グラフ表示中にエラーが発生しました:", error);
    } finally {
      this.setState({ buttonDisabled: false });
    }
  }

  async showGraph() {
    this.setState({
      isLoading: true,
    });

    const sessionCount = await this.getSessionCount();
    this.setState({
      isLoading: false,
      concurrentSession: {
        data: sessionCount.concurrentSessionData,
        options: sessionCount.concurrentSessionOptions
      },
      accumulatedSession: {
        data: sessionCount.accumulatedSessionData,
        options: sessionCount.accumulatedSessionOptions
      },
    });
  }

  async getSessionCount() {
    let labels = null;
    let concurrentSessionDatasets = null;
    let accumulatedSessionDatasets = null;
    let max = null;
    let concurrentSessionYMax = 50;
    let accumulatedSessionYMax = 100;
    let accumulatedSessionYMin = 0;
    const sessionCountDate = moment(this.state.scheduleDate).valueOf();

    let isDownloadEnabled = false;
    await organisationAction.getCustomerSessionNum(
      {
        sessionCountDate: sessionCountDate
      }
    ).then(
      response => {
        labels = response.data.data.sessionCountInfo.date.map((time) => {
          return moment(moment(this.state.scheduleDate).format("YYYY-MM-DD") + " " + time);
        });;
        concurrentSessionDatasets = response.data.data.sessionCountInfo.concurrentSession;
        accumulatedSessionDatasets = response.data.data.sessionCountInfo.accumulatedSession;
        max = response.data.data.maxConcurrentSessions;

        const maxConcurrentSessionDatasets = Math.max(...concurrentSessionDatasets);
        concurrentSessionYMax = (maxConcurrentSessionDatasets > concurrentSessionYMax) ?
          Math.round(((maxConcurrentSessionDatasets * 1.5) / 10)) * 10 : concurrentSessionYMax;
        
        const maxAccumulatedSessionDatasets = Math.max(...accumulatedSessionDatasets);
        const tmpAccumulatedSessionYMax = maxAccumulatedSessionDatasets + (concurrentSessionYMax * 2)
        accumulatedSessionYMax = (tmpAccumulatedSessionYMax > accumulatedSessionYMax) ?
          Math.round((tmpAccumulatedSessionYMax / 100)) * 100 : accumulatedSessionYMax;

        const minAccumulatedSessionDatasets = Math.min(...accumulatedSessionDatasets);
        const tmpAccumulatedSessionYMin = (minAccumulatedSessionDatasets !== Infinity) ? minAccumulatedSessionDatasets - (concurrentSessionYMax * 2): 0;
        accumulatedSessionYMin = (tmpAccumulatedSessionYMin > accumulatedSessionYMin) ?
          Math.round((tmpAccumulatedSessionYMin / 100)) * 100 : accumulatedSessionYMin;

        if (labels.length > 0) {
          isDownloadEnabled = true;
        } else {
          toastr.error(getMessage("USAGE_REPORT_NOT_FOUND"));
        }
      },
      error => {
        toastr.error(getMessage("USAGE_REPORT_SERVER_ERROR"));
        console.log(error);
      }
    );

    const annotations = {}
    if (max != null) {
      annotations.line1 = {
        type: 'line',
        yMin: max,
        yMax: max,
        borderColor: 'rgb(255, 99, 132)',
        borderWidth: 2,
      }
      if (max > concurrentSessionYMax) {
        concurrentSessionYMax = Math.round(((Math.max(max) * 1.2) / 10) * 10);
      }
    }

    const x = {
      type: 'time',
      time: {
        parser: 'HH:mm:ss',
        unit: 'hour',
        stepSize: 1,
        displayFormats: {
          hour: 'HH:mm'
        }
      }
    }

    const concurrentSessionData = {
      labels,
      datasets: [
        {
          label: getMessage("USAGE_REPORT_CONCURRENT_SESSION"),
          data: concurrentSessionDatasets,
          borderColor: "rgba(54, 162, 235, 1)",
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderJoinStyle: 'bevel',
        },
      ],
    };

    const concurrentSessionOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: false
        },
        title: {
          display: true,
          text: getMessage("USAGE_REPORT_CONCURRENT_SESSION"),
        },
        autocolors: false,
        annotation: {
          annotations: annotations
        }
      },
      scales: {
        x: x,
        y: {
          max: concurrentSessionYMax,
          min: 0,
          ticks: {
            stepSize: 10
          }
        }
      },
      elements: {
        point: {
          radius: 0
        }
      }
    };

    const accumulatedSessionData = {
      labels,
      datasets: [
        {
          label: getMessage("USAGE_REPORT_ACCUMULATED_SESSION"),
          data: accumulatedSessionDatasets,
          borderColor: "rgba(54, 162, 235, 1)",
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderJoinStyle: 'bevel',
        },
      ],
    };

    const accumulatedSessionOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: false
        },
        title: {
          display: true,
          text: getMessage("USAGE_REPORT_ACCUMULATED_SESSION"),
        },
        autocolors: false
      },
      scales: {
        x: x,
        y: {
          max: accumulatedSessionYMax,
          min: accumulatedSessionYMin,
        }
      },
      elements: {
        point: {
          radius: 0
        }
      }
    };

    this.setState({
      isDownloadEnabled: isDownloadEnabled
    });

    return { concurrentSessionData, concurrentSessionOptions, accumulatedSessionData, accumulatedSessionOptions }
  }

  async downloadCustomerSessionNumCSV() {
    const sessionCountDate = moment(this.state.scheduleDate).valueOf();
    await organisationAction.downloadCustomerSessionNumCSV(
      {
        sessionCountDate: sessionCountDate
      }
    ).then((res) => {
      const search = 'filename=';
      const contentDisposition = res.headers['content-disposition'];
      const blob = new Blob([res.data], { type: res.headers['content-type'] });

      const downloadFileName = contentDisposition.substr(contentDisposition.indexOf(search) + search.length);
      let link = document.createElement("a");
      document.querySelector(".usageReportBody").appendChild(link);
      link.style = "display: none";
      link.href = window.URL.createObjectURL(blob);
      link.download = downloadFileName;
      link.click();
    },
    error => {
      console.error("Error downloading", error);
    });
  };

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  isOutsideRange = (day) => {
    return (day.isAfter(moment().startOf('day')));
  }

  onClickSaveButton = () => {
    if (this.state.isDownloadEnabled) {
      this.downloadCustomerSessionNumCSV();
    } else {
      toastr.error(getMessage("USAGE_REPORT_NOT_FOUND"));
    }
  }

  setItem = (event) => {
    let dropDownValue = ""
    if (event.target.id == "day") {
      dropDownValue = getMessage("USAGE_REPORT_DAILY")
    } else {
      dropDownValue = getMessage("USAGE_REPORT_MONTHLY")
    }
    this.setState({
      currentSelectedItem: event.target.id,
      dropDownValue: dropDownValue
    });
  }

  renderSprinner = () => {
    return <Spinner showSpinner={this.state.isLoading} />;
  }

  render() {
    const calenderNode = (<img src={calendar_img} />)
    return (
      <div>
        {this.renderSprinner()}
        {
          <div className="usageReportContainer">
            <div className="usageReportHeader">
              <Dropdown className="mg-1" group isOpen={this.state.dropdownOpen} size="sm" toggle={this.toggleDropdown}>
                <DropdownToggle caret>
                  {this.state.dropDownValue}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    id='day'
                    onClick={this.setItem}
                  >
                    {getMessage("USAGE_REPORT_DAILY")}
                  </DropdownItem>
                  {
                  /* <DropdownItem
                    id='month'
                    onClick={this.setItem}
                  >
                    {getMessage("USAGE_REPORT_MONTHLY")}
                  </DropdownItem> */
                  }
                </DropdownMenu>
              </Dropdown>
              <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 iconContainer mg-1">
                {(this.state.currentSelectedItem === 'day') ?
                  <SingleDatePicker
                    date={this.state.scheduleDate}
                    onDateChange={this.changeDate}
                    focused={this.state.focused}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    numberOfMonths={1}
                    id="scheduleDate"
                    showDefaultInputIcon={true}
                    inputIconPosition="after"
                    customInputIcon={calenderNode}
                    displayFormat="YYYY/MM/DD"
                    monthFormat={getMessage("DATE_PICKER_FORMAT")}
                    placeholder={getMessage("DATE_PLACEHOLDER")}
                    verticalSpacing={0}
                    isOutsideRange={this.isOutsideRange}
                    hideKeyboardShortcutsPanel
                  /> :
                  <SingleDatePicker
                    date={this.state.scheduleDate}
                    onDateChange={this.changeDate}
                    focused={this.state.focused}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    numberOfMonths={1}
                    id="scheduleDate"
                    showDefaultInputIcon={true}
                    inputIconPosition="after"
                    customInputIcon={calenderNode}
                    displayFormat="YYYY/MM"
                    monthFormat={getMessage("DATE_PICKER_FORMAT")}
                    placeholder={getMessage("DATE_PLACEHOLDER")}
                    verticalSpacing={0}
                    isOutsideRange={this.isOutsideRange}
                    hideKeyboardShortcutsPanel
                  />
                }
              </div>
              <Button
                className={"customBtn searchButton"}
                disabled={this.state.buttonDisabled}
                onClick={this.search}
              >
                {getMessage("SEARCH")}
              </Button>
              <div className="buttonDisplay mg-1">
                <span>
                  <img
                    src={ic_save_icon}
                    className="button saveButton"
                    onClick={() => { this.onClickSaveButton(); }}
                    title={getMessage("SAVE")}
                  />
                </span>
              </div>
            </div>
            <div className="usageReportBody">
              {(this.state.currentSelectedItem === 'day' && this.state.concurrentSession.data) ?
                <div className="usageReportGraphArea">
                  <div className="concurrentSession mg-1">
                    <Line options={this.state.concurrentSession.options} data={this.state.concurrentSession.data} />
                  </div>
                </div> : null
              }
              {(this.state.currentSelectedItem === 'day' && this.state.accumulatedSession.data) ?
                <div className="usageReportGraphArea">
                  <div className="concurrentSession mg-1">
                    <Line options={this.state.accumulatedSession.options} data={this.state.accumulatedSession.data} />
                  </div>
                </div> : null
              }
              {/*(this.state.currentSelectedItem === 'month') ?
                <div className="usageReportGraphArea">
                  <div className="concurrentSession mg-1">
                    <Line options={} data={} />
                  </div>
                </div> : null
              }
              {(this.state.currentSelectedItem === 'month') ?
                <div className="usageReportGraphArea">
                  <div className="concurrentSession mg-1">
                    <Line options={} data={} />
                  </div>
                </div> : null
            */}
            </div>
          </div>
        }
      </div>
    )

  }

}
